@if (!isLoadingFrequent) {
  <div class="traveller-detail-container">
    <div>
      <fa-icon
        tabindex="0"
        role="button"
        [attr.aria-label]="'Add to travellers ' + traveller.forename + ' ' + traveller.surname"
        (click)="addToTraveller(traveller)"
        [icon]="faUser"
        class="add-frequent-button"
      >
      </fa-icon>
      {{ traveller.forename }} {{ traveller.surname }} ({{ ageType | titlecase }})
      @if (showInvokedLabel) {
        <span i18n="@@invoked" class="invoked-label"> - Invoked</span>
      }
    </div>
    <fa-icon
      tabindex="0"
      role="button"
      [attr.aria-label]="
        'Remove frequent traveller ' + traveller.forename + ' ' + traveller.surname
      "
      class="fa-trash-icon"
      [icon]="faTrash"
      (click)="removeFrequentTravellers(traveller)"
    >
    </fa-icon>
  </div>
} @else {
  <app-loading-spinner size="sm" />
}
